<header class="mi-app-header d-flex justify-content-center align-items-center d-md-none mc-py-3">
    <mi-app-menu class="mi-app-menu-el" />

    <mc-button class="d-flex justify-content-center mi-maslul-logo mc-transparent-button" (click)="goToHome()"
    (keyup.enter)="goToHome()" [imageSrc]="'assets/images/shared/my-import-title.svg'" [imageAlt]="commonText()?.myImport" [ariaLabel]="commonText()?.myImport"
    ></mc-button>


</header>
<header class="mi-app-header d-none d-md-flex justify-content-between mc-p-3">
    <mc-button class="d-flex justify-content-start mi-maslul-logo mc-transparent-button" (click)="goToHome()"
    (keyup.enter)="goToHome()" [imageSrc]="'assets/images/shared/my-import-title.svg'" [imageAlt]="commonText()?.myImport" [ariaLabel]="commonText()?.myImport"
    ></mc-button>
    <div class="d-flex mc-w-10 justify-content-evenly align-items-center">

        <!-- <div class="mi-header-language mc-me-4">
            <div class="d-flex  align-items-center " (click)="toggleLanguage()">
                <i class=" icon-world mc-me-1"></i>
                <span>עברית</span>
                <i class="icon-Color-Overlay  mc-ms-1"></i>
            </div>
            @if(isOpenLanguage){
            <ul class="mi-header-language-menu">
                <li><span>עברית</span></li>
                <li><span>english</span></li>

            </ul>
            }
        </div> -->
        <div class="d-flex align-items-center">
            <mc-button [label]="'1299'" [ariaLabel]="'1299'" [icon]="'icon-phone-call-1 mc-me-2'" class="mi-button-with-icon-black" 
            [cdkCopyToClipboard]="'1299'" (click)="onCopy()" (keyup.enter)="onCopy()"
           >
          </mc-button>
            <!-- <i class=" icon-phone-call-1 mc-me-2"> </i>
            <span [cdkCopyToClipboard]="'1299'" (click)="onCopy()" tabindex="0" role="button"
                (keyup.enter)="onCopy()">1299</span> -->

            <!-- @if(isCopied){
            <p style="position: absolute; background-color: white;top: 4rem;">✅ הועתק בהצלחה!</p>

            } -->
        </div>
    </div>


</header>